@if (action == 'index') {
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="fs-2 fw-light mt-4">Choose Property - Laws</h1>
            <button (click)="goHome()" class="btn btn-primary">Home <fa-icon [icon]="faHouseChimney"></fa-icon></button>
        </div>

        <div class="form-group has-search my-3">
            <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
            <input type="text" name="searchProperty" [(ngModel)]="searchProperty" class="form-control" placeholder="Search by property name" />
        </div>

        @if (loadingProperties) {
            <div class="my-4">
                <span class="spinner-border spinner-border-sm mr-1"></span>
                <span>Loading properties...</span>
            </div>
        }

        @if (!loadingProperties && properties.length == 0) {
            <div class="alert alert-info">No properties found.</div>
        }

        <ul class="list-group list-group-flush col-md-6">
            @for (property  of properties | filter: searchProperty ; track property ) {
                <li (click)="onSelectedProperty(property)" class="fs-3 text-primary list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                    @if (property.property_type == 'house') {
                        <fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
                    }
                    @if (property.property_type == 'strata') {
                        <fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
                    }
                    @if (property.property_type == 'Townhouse') {
                        <fa-icon class="l-icon" [icon]="faHouseChimney"></fa-icon>
                    }
                    <span class="text-black fw-lighter">{{property.name}} </span>
                    <fa-icon [icon]="faCircleArrowRight"></fa-icon>
                </li>
            }
        </ul>
    </div>
}

@if (action != 'index' && !property?.id) {
    <div class="container">
        <h1 class="fs-2 fw-light mt-4">Manage Laws</h1>
        <div class="alert alert-warning mt-4">
            No property selected. Choose a property first to manage laws.
        </div>
        <button (click)="goBack()" type="button" class="btn btn-primary">
            <fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
        </button>
    </div>
}

@if (action != 'index' && property?.id && properties.length > 1) {
    <div class="container mt-3">
        <button (click)="onChangeProperty()" type="button" class="btn btn-sm btn-outline-secondary">Change property</button>
    </div>
}

@if (property?.id && action == 'create') {
    <div class="container">
        <h1 class="fs-2 fw-light mt-4">Create Law</h1>
        <form [formGroup]="addLawForm">
            <div class="form-group my-4">
                <label class="form-label" for="title">Title</label>
                <input
                    class="form-control"
                    type="text"
                    id="title"
                    placeholder="Law title"
                    formControlName="title"
                    [ngClass]="{ 'is-invalid': submitLawData && fla.title.errors, 'is-valid': fla.title.valid && fla.title.touched }"
                />
            </div>

            <div class="form-group my-4">
                <label class="form-label" for="description">Description</label>
                <textarea
                    class="form-control"
                    id="description"
                    rows="5"
                    placeholder="Law description"
                    formControlName="description"
                    [ngClass]="{ 'is-invalid': submitLawData && fla.description.errors, 'is-valid': fla.description.valid && fla.description.touched }"
                ></textarea>
            </div>

            <div class="form-group my-4">
                <label class="form-label" for="propertyName">Property</label>
                <input class="form-control" id="propertyName" type="text" formControlName="propertyName" readonly />
                <input type="hidden" formControlName="propertyId" />
            </div>
        </form>
    </div>
}

@if (property?.id && action == 'edit') {
    <div class="container">
        <h1 class="fs-2 fw-light mt-4">Edit Law</h1>
        <form [formGroup]="editLawForm">
            <input type="hidden" formControlName="id" />

            <div class="form-group my-4">
                <label class="form-label" for="editTitle">Title</label>
                <input
                    class="form-control"
                    type="text"
                    id="editTitle"
                    placeholder="Law title"
                    formControlName="title"
                    [ngClass]="{ 'is-invalid': submitLawData && fle.title.errors, 'is-valid': fle.title.valid && fle.title.touched }"
                />
            </div>

            <div class="form-group my-4">
                <label class="form-label" for="editDescription">Description</label>
                <textarea
                    class="form-control"
                    id="editDescription"
                    rows="5"
                    placeholder="Law description"
                    formControlName="description"
                    [ngClass]="{ 'is-invalid': submitLawData && fle.description.errors, 'is-valid': fle.description.valid && fle.description.touched }"
                ></textarea>
            </div>

            <div class="form-group my-4">
                <label class="form-label" for="editPropertyName">Property</label>
                <input class="form-control" id="editPropertyName" type="text" formControlName="propertyName" readonly />
                <input type="hidden" formControlName="propertyId" />
            </div>
        </form>
    </div>
}

@if (property?.id && action == 'view') {
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="fs-2 fw-light mt-4">View Law</h1>
            <button (click)="onEditLaw()" type="button" class="mt-4 btn btn-primary">
                Edit <fa-icon [icon]="faPenToSquare"></fa-icon>
            </button>
        </div>

        <form [formGroup]="viewLawForm">
            <div class="form-group my-4">
                <label class="form-label" for="viewTitle">Title</label>
                <input class="form-control" id="viewTitle" type="text" formControlName="title" readonly />
            </div>

            <div class="form-group my-4">
                <label class="form-label" for="viewDescription">Description</label>
                <textarea class="form-control" id="viewDescription" rows="5" formControlName="description" readonly></textarea>
            </div>

            <div class="form-group my-4">
                <label class="form-label" for="viewProperty">Property</label>
                <input class="form-control" id="viewProperty" type="text" formControlName="propertyName" readonly />
            </div>
        </form>
    </div>
}

@if (property?.id && action == 'list') {
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="fs-2 fw-light mt-4">Manage Laws</h1>
            <button (click)="onCreateLaw()" type="button" class="mt-4 btn btn-primary">
                Add <fa-icon [icon]="faCirclePlus"></fa-icon>
            </button>
        </div>

        <p class="text-muted">Property: {{ property.name }}</p>

        <div class="form-group has-search my-3">
            <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
            <input type="text" name="searchLaw" [(ngModel)]="searchLaw" class="form-control" placeholder="Search laws" />
        </div>

        @if (loading) {
            <div class="my-4">
                <span class="spinner-border spinner-border-sm mr-1"></span>
                <span>Loading laws...</span>
            </div>
        }

        @if (!loading && laws.length == 0) {
            <div class="alert alert-info">No laws found for this property. Create your first law.</div>
        }

        <ul class="list-group list-group-flush">
            @for (law of laws; track law.id) {
                @if ((law.title + ' ' + law.description).toLowerCase().includes(searchLaw.toLowerCase())) {
                    <li class="list-group-item">
                        <div class="d-flex justify-content-between align-items-start gap-2">
                            <button class="btn btn-link text-start p-0 text-decoration-none" type="button" (click)="onSelectedLaw(law)">
                                <div class="d-flex align-items-center gap-2">
                                    <strong class="text-primary">{{ law.title }}</strong>
                                    <fa-icon [icon]="faCircleArrowRight"></fa-icon>
                                </div>
                                <div class="text-muted small mt-1">{{ law.description }}</div>
                            </button>
                        </div>
                    </li>
                }
            }
        </ul>
    </div>
}

@if (property?.id) {
    <div class="mt-4 d-flex container justify-content-between align-items-center">
        <button (click)="goBack()" type="button" class="btn btn-primary">
            <fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
        </button>

        @if (action == 'create') {
            <button [disabled]="fetching" class="btn btn-primary" (click)="createLaw()">
                Save
                @if (!fetching) {
                    <fa-icon [icon]="faPaperPlane"></fa-icon>
                }
                @if (fetching) {
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                }
            </button>
        }

        @if (action == 'edit') {
            <div class="d-flex gap-2">
                <button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteLaw()">
                    Delete <fa-icon [icon]="faTrash"></fa-icon>
                </button>
                <button [disabled]="fetching" class="btn btn-info" (click)="updateLaw()">
                    Update
                    @if (!fetching) {
                        <fa-icon [icon]="faPaperPlane"></fa-icon>
                    }
                    @if (fetching) {
                        <span class="spinner-border spinner-border-sm mr-1"></span>
                    }
                </button>
            </div>
        }

        @if (action == 'view') {
            <button [disabled]="fetching" class="btn btn-danger" (click)="onDeleteLaw()">
                Delete <fa-icon [icon]="faTrash"></fa-icon>
            </button>
        }
    </div>
}
